export class SideBar {
    constructor(item) {
        this.url = '';
        this.url_router = '';
        this.label = '';
        this.tab_id = '';
        this.is_open = false;
        this.lang_key = '';
        this.icon = '';
        this.class = '';
        this.title = '';
        this.display = true;
        this.is_active = false;
        this.subitem = [];
        this.subitems = [];
        if (!!item) {
            this.setItem(item);
        }
    }

    setItem(item) {
        let item_keys = Object.keys(item);
        let vm = this;
        item_keys.map(f => {
            if ((f === 'subitem' || f === 'subitems')  && item[f].length > 0) {
                item[f].forEach(obj => {
                    vm[f].push(new SubTab(obj))
                });
            } else {
                this[f] = item[f]
            }
        });
    }
}

class SubTab {
    constructor(item) {
        this.url = '';
        this.url_router = '';
        this.label = '';
        this.tab_id = '';
        this.lang_key = '';
        this.icon = '';
        this.title = '';
        this.class = '';
        this.is_active = false;
        this.display = true;
        if (!!item) {
            this.setItem(item);
        }
    }

    setItem(item) {
        let item_keys = Object.keys(item);
        item_keys.map(f => {
            this[f] = item[f]
        });
    }
}
